import { useState, useEffect } from 'react'
import { auth, db } from '../firebase/config'
import { doc, serverTimestamp, setDoc } from "firebase/firestore"
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'
import { useAuthContext } from './useAuthContext'

export const useSignup = () => {
  const [isCancelled, setIsCancelled] = useState(false)
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthContext()

  const signup = async (email, password, displayName) => {
    setError(null)
    setIsPending(true)
  
    try {
      // signup
      const res = await createUserWithEmailAndPassword(auth, email, password)

      if (!res) {
        throw new Error('Could not complete signup')
      }

      // add display name (AND PHOTO_URL [not yet implemented]) to user
      await updateProfile( res.user, { displayName })

      // create a user document
      await setDoc(doc(db, 'USERS', res.user.uid), { 
        uID:res.user.uid, // firebase user id
        e:email, // main email 
        d:displayName, // as in firebase displayName
        t:serverTimestamp(), // created at
        o:true, // online status
        C:[], // list of my colleagues 
        J:[], // list of projects i am participating
        K:[], // list of knmX blocks
        G:[], // list of knmG blocks
      })

      // create a Email-uID document
      await setDoc(doc(db, 'EMAILuID', res.user.email), { 
        uID:res.user.uid, // firebase user id
        e:email, // main email 
        d:displayName, // as in firebase displayName
        t:serverTimestamp(), // created at
      })

      // dispatch login action
      dispatch({ type: 'LOGIN', payload: res.user })

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
    } 
    catch(err) {
      if (!isCancelled) {
        setError(err.message)
        setIsPending(false)
      }
    }
  }

  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  return { signup, error, isPending }
}